import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArgumentPipe',
  pure: false,
  standalone: false,
})
export class FilterArgumentPipe implements PipeTransform {
  transform<T, TArgs extends any[]>(
    items: T[],
    callback: (item: T, ...args2: TArgs) => boolean,
    ...args: TArgs
  ): T[] {
    if (!items || !callback) {
      return items;
    }
    return items.filter(item => callback(item, ...args));
  }
}
